import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "../../utils/page-title";

export const Route = createFileRoute("/wizard/report-lab")({
  head: () =>
    pageHead("Your Human Design Report · Overview", {
      canonicalPath: "/wizard/report-lab",
      robots: "noindex, nofollow",
    }),
});
